import benefits from "./benefits";

export default [benefits];
